import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { RinglessCard } from 'components/CreateElement/RinglessCard/RinglessCard'
import { SendFromComponentVR } from 'components/CreateElement/SendFromComponentVR'
import { CreateStoreTypes } from 'components/CreateElement/store/types'
import { EnableCallBackInput } from 'src/widgets/EnableCallBackInput/EnableCallBackInput'

export const RinglessContent = observer(
  ({ store }: { store: CreateStoreTypes }) => {
    useEffect(() => {
      if (store.phonePull?.type === 'TEST_TOLL_FREE') {
        store.ringlessStore.setCallbackEnabled(false)
      }
    }, [store.phonePull?.type])
    return (
      <>
        <RinglessCard ringlessStore={store.ringlessStore} />
        <EnableCallBackInput
          callbackEnabled={store.ringlessStore.callbackEnabled}
          setCallbackEnabled={store.ringlessStore.setCallbackEnabled}
          disabledError={
            store.phonePull?.type === 'TEST_TOLL_FREE'
              ? 'Call Back tracking is unavailable with test number.'
              : ''
          }
        />
        <SendFromComponentVR store={store} />
      </>
    )
  }
)
